module.exports = require("core-js/modules/es.array.is-array.js");